import { cookies } from 'globalState/elements/cookies.js';
import { EmptyEventsInstance } from './AmplitudeEventsInstance/EmptyEventsInstance.ts';
import { PerformanceObserverAdapter } from './PerformanceObserverAdapter/PerformanceObserverAdapter.ts';
import { MeasurementProtocolInstance } from './MeasurementProtocolInstance/MeasurementProtocolInstance.ts';

export const amplitudeEventsInstance = new EmptyEventsInstance();

export const eventsSender = async (eventGroup, eventName, eventValue) => {
    return amplitudeEventsInstance.sendEvent(eventGroup, eventName, eventValue);
};

export const measurementProtocolInstance = new MeasurementProtocolInstance();

export const eventsSenderYandex = async (_, eventName, eventValue) => {
    return measurementProtocolInstance.sendEvent(_, eventName, eventValue);
};

/**
 * @doc https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
 */
export const eventsSenderWithPerfomance = function () {
    if (!window.PerformanceObserver) {
        eventsSender(...arguments);
        return;
    }

    const performanceObserverAdapter = new PerformanceObserverAdapter();
    performanceObserverAdapter.run().then((performanceData) => {
        arguments[2] = {
            ...arguments[2],
            ...performanceData,
        };
        eventsSender(...arguments);
    });
};

export const eventsSenderBackend = (
    eventGroup,
    eventName,
    eventValue,
    callback
) => {
    if (callback) {
        callback();
    }
};

export const getIds = () => {
    const sessionId = cookies.getCookie('amplitudeSessionId');
    const deviceId = cookies.getCookie('amplitudeDeviceId');
    return {
        session_id: sessionId,
        device_id: deviceId,
    };
};
